module.exports = __webpack_public_path__ + "static/media/chantal_tan.d0f455c6.png";